// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"60c049c15a77a004","9185":"0e2f4ab93633896f"}[chunkId] + ".js";
};